require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/angular/index.js
// module id = 1
// module chunks = 0